import { _sharedReducerPlayer, _sharedStatePlayer } from "@/shared/store/player/reducer";

export const initialState = _sharedStatePlayer;

const playerReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return _sharedReducerPlayer(state, action);
  }
};

export default playerReducer;
